
<template>
  <div class="goodLossSummaryReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">物资耗用汇总表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>日期</span>
            <el-date-picker size="small" v-model="order.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" @change="changeTime(0)" :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker size="small" v-model="order.endDate" type="date" placeholder="结束日期" @change="changeTime(1)" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.baseId" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="pondList.length>0">
            <span>塘口</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.pondId">
              <el-option v-for="(item, index) in pondList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>物资类型</span>
            <el-select v-model="order.fishStockAbstract" size="small" placeholder="请选择" @change="fishListChange">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="order.fishStockAbstract!=''">
            <span>物资名称</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.materialId" style="">
              <el-option v-for="(item, index) in fishList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="search(1)">查询</el-button>
            <ExportExcelBtn
              apiUrl="/api/MaterialReport/Export"
              :queryParamsObj="queryParams"
              fileName="物资耗用汇总表.xls"
            />
          </div>
        </div>
      </div>
      <div class="table-container">
        <!-- 表头 -->
        <table class="table-package" :class="isTop ? 'fix' : ''">
          <thead class="table-thead">
            <tr>
              <th>物资类型</th>
              <th>物资名称</th>
              <th>计量单位</th>
              <th>耗用数量</th>
              <th>金额</th>
            </tr>
          </thead>
        </table>
        <!-- 表体 -->
        <div class="scroll-box" ref="scrollBox">
          <table class="table-package">
            <tbody class="table-tbodys" v-if=" reportData.length !== 0">
              <tr v-for="(item,index) in reportData" :key="index">
                <td>{{ getMaterialTypeName(item.fishStockAbstract) }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ formatAmount(item.amount) }}</td>
              </tr>
            </tbody>
            <tbody class="table-tbodys" v-if=" reportData.length === 0">
              <tr>
                <td colspan="5">该时间段暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 表尾 -->
        <table class="table-package">
          <tfoot class="table-tfoot" v-if="reportData.length !== 0">
            <tr class="row">
              <td>合计</td>
              <td>--</td>
              <td>--</td>
              <td>{{total('quantity').toFixed(2)}}</td>
              <td>{{total('amount').toFixed(2)}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import ExportExcelBtn from "../common/ExportExcelBtn";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";

export default {
  mixins: [mixins],
  name: "goodLossSummaryReport",
  components: {
    ExportExcelBtn,
  },
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "10001",
          label: "饲料"
        },
        {
          value: "10002",
          label: "渔药"
        },
        {
          value: "10003",
          label: "疫苗"
        }
      ],
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      order: {
        fishStockAbstract: "", //物资类型
        baseId: "", //基地
        pondId: "", //塘口
        startDate: "", //开始时间
        endDate: "", //结束时间
        materialId: "" //物资名称
      },
      baseList: [],
      pondList: [],
      fishList: [],
      reportData: [],
      isTop: false,
      fixWidth: 0
    };
  },
  computed: {
    queryParams () {
      return {
        ...this.order,
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
      };
    },
  },
  async mounted() {
    // 监听滚动
    window.addEventListener("scroll", this.getScroll, true);
    // 设置表头宽度
    this.fixWidth = this.$refs.scrollBox.offsetWidth - 5;
    window.onresize = () => {
      return (() => {
        this.fixWidth = this.$refs.scrollBox.offsetWidth;
      })();
    };

    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.order.baseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    await this.baseChange(this.order.baseId);
    this.search(1);
  },
  methods: {
    //监听滚动
    getScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 180) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },

    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.report, {
      getMaterialReport: "getMaterialReport"
    }),
    ...mapActions(modules.fish, {
      getFishList: "getFishList",
      getFeedNameList: "getFeedNameList",
      getFishMedicineList: "getFishMedicineList",
      getPreventNameList: "getPreventNameList"
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond"
    }),
    getMaterialTypeName(fishStockAbstract) {
      const typeMap = {
        10001: "饲料",
        10002: "渔药",
        10003: "疫苗",
        10004: "渔肥",
      };
      return typeMap[Number(fishStockAbstract)] || "--";
    },
    formatAmount(amount) {
      const value = Number(amount);
      return Number.isFinite(value) ? value.toFixed(2) : "--";
    },
    //总计
    total(prop) {
      let total = 0;
      // this.reportData.forEach(item => (total += Number(item[prop])));
      // this.reportData.forEach(item => {
      //   if (item.quantity) {
      //     total += item.quantity;
      //   }
      // });
      this.reportData.forEach(item => (total += Number(item[prop])));
      return total;
    },
    //改变基地数据
    async baseChange(e) {
      storage.set("base", e);
      this.pondList = [];
      let result = [];
      if (!e) {
        result = [];
      } else {
        result = await this.getFishPond(e);
      }
      this.pondList = [
        {
          key: "",
          value: "全部"
        }
      ].concat(result);
      if (this.pondList.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下面无塘口，请先添加",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地下面无塘口，请先添加");
      }
    },
    async fishListChange(e) {
      let result = [];
      switch (e) {
        case "":
          this.fishList = [];
          break;
        case "10001":
          result = await this.getFeedNameList();
          break;
        case "10002":
          result = await this.getFishMedicineList();
          break;
        case "10003":
          result = await this.getPreventNameList();
          break;
        default:
          break;
      }

      this.fishList = [
        {
          id: "",
          name: "全部"
        }
      ].concat(result);
      this.order.materialId = "";
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.order.startDate);
      } else {
        storage.set("end", this.order.endDate);
      }
    },
    //查询
    search() {
      this.getMaterialReport(this.queryParams)
        .then(rsp => {
          this.reportData = rsp;
        })
        .catch(err => {
          console.dir(err);
        });
    }
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.order.startDate = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      start.setMonth(0);
      this.order.startDate = this.$timeformatDay(start);
    }
    if (endTime) {
      this.order.endDate = endTime;
    } else {
      this.order.endDate = this.$timeformatDay(new Date());
    }
  }
};
</script>
<style lang="stylus" >

.goodLossSummaryReport
  .scroll-box
    width 100%
    // max-height 550px
    // overflow auto
    // overflow-x hidden

  .table-package
    width 100%
    border-collapse collapse
    // border 1px #ddd solid
    border:none;
  .table-thead
    border-top 2px solid rgb(51, 137, 255)

    >tr th
      width 20%
      text-align center
      height 50px
      font-size 14px
      line-height 50px
      color #666
      font-weight bold
      border 1px solid #e0e0e0
      border-bottom 1px solid rgb(51, 137, 255)
      background-color: #f7f7f7;
  .table-tbodys
    :hover
      background #c3e3ff

    tr
      text-align center
      height 37px
      line-height 37px
      border 1px solid #ddd
      border:none;
      background-color #fff

    td
      width 20%
      border 1px solid #e0e0e0
      border-top:none;
      color #666

  .table-tfoot
    tr>td
      text-align center
      height 37px
      line-height 37px
      color #333
      font-size 14px

    .row
      font-size 14px
      background-color #fff
      font-weight bold

      >td
        width 20%
        text-align center
        border 1px solid #e0e0e0
        // color #666
        border-top:none;
        font-weight bold

  .hidden
    display none

.goodLossSummaryReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
  width: calc(100% - 250px);
}
</style>
